import { render } from "./NavbarComponent.vue?vue&type=template&id=0f6725df&scoped=true&ts=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts"

import "./NavbarComponent.vue?vue&type=style&index=0&id=0f6725df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6725df"]])

export default __exports__